export enum ComparisonToolTableHeader {
    ADDITIONAL_AREAS = "additionalAreas",
    AREA = "area",
    CONSTRUCTION_DATE = "constructionDate",
    DISTANCE = "distanceFromCenter",
    FLOOR = "floor",
    FLOORS = "floors",
    KITCHEN = "kitchen",
    CONTACT = "contact",
    PRICE = "price",
    ROOM_HEIGHT = "roomHeight",
    ROOMS = "rooms",
    QUARTERS = "quarters",
    // NOTES = "notes", TODO: Add in phase 2
    CHANGE_PLACE = "changePlace"
}
export enum ComparisonToolTableHeader {
    ADDITIONAL_AREAS = "additionalAreas",
    AREA = "area",
    CONSTRUCTION_DATE = "constructionDate",
    DISTANCE = "distanceFromCenter",
    FLOOR = "floor",
    FLOORS = "floors",
    KITCHEN = "kitchen",
    CONTACT = "contact",
    PRICE = "price",
    ROOM_HEIGHT = "roomHeight",
    ROOMS = "rooms",
    QUARTERS = "quarters",
    // NOTES = "notes", TODO: Add in phase 2
    CHANGE_PLACE = "changePlace"
}
